import {Pipe, PipeTransform} from '@angular/core';
import {PortalUser} from "@app/model/portal-user.model";
import {TicketUser} from "@app/services/tickets/tickets.service";
import {CreditUnion} from "@app/pages/admin/admin.component";

@Pipe({
    name: 'toName',
})
export class UsernameToNamePipe implements PipeTransform {
    transform(username: string, userArray: any[], option: 'PortalUser' | 'TicketUser' | 'CreditUnion' = 'PortalUser') {
        switch (option) {
            case "PortalUser":
                let tempUser: PortalUser;
                tempUser = userArray.find(filter => filter.username.trim().toUpperCase() === username.trim().toUpperCase()) as PortalUser
                return tempUser ? `${username} - ${tempUser.firstName} ${tempUser.lastName}` : `${username}`;
            case "TicketUser":
                let ticketUser: TicketUser;
                ticketUser = userArray.find((user: TicketUser) => user.username.trim().toUpperCase() === username.trim().toUpperCase()) as TicketUser
                return ticketUser ? `${username} - ${ticketUser.fullName}` : `${username}`;
            case "CreditUnion":
                let tempCU: CreditUnion;
                tempCU = userArray.find(filter => filter.cuid.trim().toUpperCase() === username.trim().toUpperCase()) as CreditUnion
                return tempCU ? `${username} - ${tempCU.name}` : `${username}`;
        }

    }
}
